module.exports = __webpack_public_path__ + "img/artstation.12d4587a.svg";